var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVerified = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.917,
  d: "M9.166 5.958c0 2.292-1.604 3.438-3.51 4.102a.46.46 0 0 1-.308-.004c-1.91-.66-3.515-1.806-3.515-4.098V2.75a.46.46 0 0 1 .458-.458c.917 0 2.063-.55 2.86-1.247a.536.536 0 0 1 .697 0c.802.701 1.943 1.247 2.86 1.247a.46.46 0 0 1 .458.458z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.917,
  d: "m4.125 5.5.917.917 1.833-1.834"
})));
export default SvgVerified;